module.exports = __webpack_public_path__ + "static/img/overview@t.22d1d44.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/siliconwork-renewal/overview@t.jpg
// module id = +qWa
// module chunks = 0